/*
 * @Author: Chao Yang
 * @Date: 2020-04-08 10:51:02
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-04-08 10:51:53
 */
export enum WidgetEnum {
  CapitalBalance = 1,
  Subscribed,
  Redeemed,
  Contributed,
  Distributed,
  HistoricalNavChart,
  ContributedVsCommitmentTracker,
  Tasks,
  UnreadDocs,
  NewDocuments,
  Description,
  PriorYearTaxDocuments,

  Addition,
  CashBalance,
  ContributionExpenses,
  ContributionMgmtFees,
  Commitment,
  EquityContributions,
  GrossPNL,
  GrossROR,
  IncentiveFee,
  ManagementFee,
  NetPNL,
  OtherEquityAdjustments,
  OutstandingCommitment,
  ReturnOfCapital,
  ReturnOfCapitalRecallable,
  Withdrawal,
}
